
































































































































































































import { Vue, Component } from "nuxt-property-decorator";
import GrCheckListItem from "~/components/GrCheckListItem.vue";
import LandingSiteCompanies from "~/components/LandingSiteCompanies.vue";
import GrPublicFooter from "~/components/startPageNew/GrPublicFooter.vue";
import CommonHelpers from "~/helpers/CommonHelpers";

@Component({
  components: { GrPublicFooter, GrCheckListItem, LandingSiteCompanies },
  nuxtI18n: false,
})
export default class ItJobsPage extends Vue {
  tab = 0;

  get rootUrl(): string {
    return CommonHelpers.getBaseUrl();
  }

  get description(): string {
    return "Sugen på nytt jobb? På Gritify matchas din kompetens, ditt löneanspråk och dina krav på en potentiell arbetsgivare mot lediga IT-jobb i Stockholm.";
  }

  get title(): string {
    return "Hitta ditt nästa IT-jobb i Stockholm";
  }

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          property: "og:title",
          content: this.title,
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:url",
          content: `${this.rootUrl}${this.$route.path}`,
        },
        {
          property: "og:description",
          content: this.description,
        },
        {
          name: "twitter:title",
          content: this.title,
        },
        {
          name: "twitter:description",
          content: this.description,
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
    };
  }

  get titleFontSize(): string {
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
      case "sm":
        return "30px";
      case "md":
        return "40px";
      case "lg":
      case "xl":
        return "60px";
    }
  }

  get getStartedLink(): string {
    return this.localePath({
      name: "talentStart-createProfileStart",
    });
  }
}
